

















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import SchedulesStore from "@/store/modules/SchedulesStore";
import ScheduleOptionSelector from "@/components/OptionSelector/ScheduleOptionSelector.vue";
import ListSorter from "@/components/ListSorter/ListSorter.vue";

@Component({
    components: {
        ListSorter,
        ScheduleOptionSelector,
    },
})

export default class ScheduleList extends Vue {
    @Prop() private selected!: string;

    get scheduleIds() {
        if (this.selected === 'period') {
            return SchedulesStore.period.map(v => v.id);
        } else {
            return SchedulesStore.day.map(v => v.id);
        }
    }

    get menuId(): number {
        return Number(this.$route.params['menuId']);
    }

    private schedule(id: number): CMS.Schedule {
        return SchedulesStore.scheduleById[id] || {};
    }

    private weeks(scheduleId: number): number[] {
        return this.schedule(scheduleId).weeks || [];
    }

}

